module.exports = __webpack_public_path__ + "img/rocket_tubes_1979_playthings_ad.64ed54d2.jpg";